import React from 'react'
import { Redirect } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import useLogin from '../../hooks/useLogin'
import LoadingSpinner from '../LoadingSpinner'

export function AuthRouteWrapper({ LoadingComponent, children, redirectTo = '/', authorized, loading }) {
  const LoadingEl = LoadingComponent || LoadingSpinner
  const { signedIn, userLoading } = useUser()
  const { login } = useLogin()

  if (loading || userLoading) {
    return <LoadingEl />
  }

  if (!signedIn) {
    login()
    return null
  }

  if (!authorized) {
    return <Redirect to={redirectTo} />
  }

  return children
}
